<template>
  <div v-if="visible" class="novo-admin-aviso">
    <div class="novo-admin-aviso__backdrop" @click="fechar"></div>
    <div class="novo-admin-aviso__modal" role="dialog" aria-modal="true">
      <div class="novo-admin-aviso__header">
        <i class="ace-icon fa fa-bullhorn"></i>
        <h3>Novo gerenciador de conteúdo</h3>
      </div>
      <div class="novo-admin-aviso__body">
        <p>
          Disponibilizamos um novo painel para gerenciar o conteúdo do site da Prefeitura.
          O acesso continua com a <strong>mesma conta</strong> que você já utiliza neste sistema.
        </p>
        <p class="novo-admin-aviso__link-wrap">
          Acesse em:
          <a
            href="https://admin.aquidauana.ms.gov.br/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://admin.aquidauana.ms.gov.br/
          </a>
        </p>
        <label class="novo-admin-aviso__check">
          <input type="checkbox" v-model="naoMostrar" />
          <span>Não mostrar novamente por 1 semana</span>
        </label>
      </div>
      <div class="novo-admin-aviso__footer">
        <button type="button" class="btn btn-default" @click="fechar">
          Fechar
        </button>
        <a
          href="https://admin.aquidauana.ms.gov.br/"
          target="_blank"
          rel="noopener noreferrer"
          class="btn btn-primary"
          @click="aoAcessar"
        >
          Acessar novo painel
        </a>
      </div>
    </div>
  </div>
</template>

<script>
const STORAGE_KEY = '_novo_admin_aviso_oculto_ate'
const UMA_SEMANA_MS = 7 * 24 * 60 * 60 * 1000

export default {
  name: 'NovoAdminAviso',
  data () {
    return {
      visible: false,
      naoMostrar: false
    }
  },
  mounted () {
    this.visible = this.deveExibir()
  },
  methods: {
    deveExibir () {
      const ocultoAte = localStorage.getItem(STORAGE_KEY)
      if (!ocultoAte) return true
      const timestamp = Number(ocultoAte)
      if (Number.isNaN(timestamp)) return true
      return Date.now() > timestamp
    },
    fechar () {
      if (this.naoMostrar) {
        localStorage.setItem(STORAGE_KEY, String(Date.now() + UMA_SEMANA_MS))
      }
      this.visible = false
    },
    aoAcessar () {
      this.fechar()
    }
  }
}
</script>

<style lang="stylus" scoped>
.novo-admin-aviso
  position fixed
  top 0
  right 0
  bottom 0
  left 0
  z-index 1050
  display flex
  align-items center
  justify-content center
  padding 16px

.novo-admin-aviso__backdrop
  position absolute
  top 0
  right 0
  bottom 0
  left 0
  background rgba(0, 0, 0, 0.55)

.novo-admin-aviso__modal
  position relative
  width 100%
  max-width 480px
  background #fff
  border-radius 4px
  box-shadow 0 8px 32px rgba(0, 0, 0, 0.35)
  overflow hidden

.novo-admin-aviso__header
  display flex
  align-items center
  padding 16px 20px
  background #438eb9
  color #fff

  i
    margin-right 10px
    font-size 20px

  h3
    margin 0
    font-size 18px
    font-weight 600
    color #fff

.novo-admin-aviso__body
  padding 20px

  p
    margin 0 0 14px
    font-size 14px
    line-height 1.55
    color #555

.novo-admin-aviso__link-wrap
  a
    display inline-block
    margin-top 4px
    font-weight 600
    color #438eb9
    word-break break-all

    &:hover
      text-decoration underline

.novo-admin-aviso__check
  display flex
  align-items flex-start
  margin-top 4px
  cursor pointer
  font-size 13px
  color #666

  input
    margin 2px 8px 0 0

.novo-admin-aviso__footer
  display flex
  justify-content flex-end
  padding 12px 20px 16px
  border-top 1px solid #e5e5e5

  .btn
    margin-left 8px
</style>
